// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Env = require("../../reason/common/Env.bs.js");
var ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var AuthSession = require("../../utils/AuthSession.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var ReactRender = require("../../reason/utils/ReactRender.bs.js");
var UserSession = require("../../reason/common/UserSession/UserSession.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var TailwindMerge = require("tailwind-merge");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var UseShouldShowPropertyDetails = require("../common/Hooks/UseShouldShowPropertyDetails.bs.js");
var PropertyPageNavbar_property_graphql = require("../../__generated__/PropertyPageNavbar_property_graphql.bs.js");

function PropertyPage__Navbar$Navbar$Link(props) {
  return JsxRuntime.jsx("a", {
              children: props.text,
              className: "text-gray-700 font-medium",
              href: props.to_
            });
}

var Link = {
  make: PropertyPage__Navbar$Navbar$Link
};

function PropertyPage__Navbar$Navbar(props) {
  var propertyId = props.propertyId;
  var shouldShowPropertyDetails = props.shouldShowPropertyDetails;
  var tanStaff = Core__Option.getOr(Core__Option.map(UserSession.useAgentInfoOpt(), (function (v) {
              return v.tanStaff;
            })), false);
  var isImpersonated = AuthSession.useIsImpersonated();
  var match = isImpersonated || tanStaff;
  return JsxRuntime.jsxs("nav", {
              children: [
                JsxRuntime.jsxs("ul", {
                      children: [
                        (function (__x) {
                              return ReactRender.ifTrue(JsxRuntime.jsx("li", {
                                              children: JsxRuntime.jsx(PropertyPage__Navbar$Navbar$Link, {
                                                    text: "Files",
                                                    to_: "#files"
                                                  }),
                                              className: "p-4 first:pl-0"
                                            }), __x);
                            })(props.hasFiles && shouldShowPropertyDetails),
                        (function (__x) {
                              return ReactRender.ifTrue(JsxRuntime.jsx("li", {
                                              children: JsxRuntime.jsx(PropertyPage__Navbar$Navbar$Link, {
                                                    text: "Showings",
                                                    to_: "#showings"
                                                  }),
                                              className: "p-4 first:pl-0"
                                            }), __x);
                            })(props.propertyType === "ForSale"),
                        (function (__x) {
                              return ReactRender.ifTrue(JsxRuntime.jsx("li", {
                                              children: JsxRuntime.jsx(PropertyPage__Navbar$Navbar$Link, {
                                                    text: "Location",
                                                    to_: "#location"
                                                  }),
                                              className: "p-4 first:pl-0"
                                            }), __x);
                            })(shouldShowPropertyDetails),
                        JsxRuntime.jsx("li", {
                              children: JsxRuntime.jsx(PropertyPage__Navbar$Navbar$Link, {
                                    text: "Activity",
                                    to_: "#activity"
                                  }),
                              className: "p-4 first:pl-0"
                            }),
                        JsxRuntime.jsx("li", {
                              children: JsxRuntime.jsx(PropertyPage__Navbar$Navbar$Link, {
                                    text: "Conversations",
                                    to_: "#conversations"
                                  }),
                              className: "p-4 first:pl-0"
                            })
                      ],
                      className: "flex overflow-scroll sm:[scrollbar-width:none]"
                    }),
                propertyId !== undefined && match ? JsxRuntime.jsx("a", {
                        children: JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                              size: "small",
                              children: "Open in Admin App"
                            }),
                        className: "hover:no-underline",
                        href: Env.adminAppUrl + "/properties/" + propertyId,
                        rel: "noreferrer noopener",
                        target: "_blank"
                      }) : null
              ],
              className: TailwindMerge.twMerge([
                    props.hasImages ? "" : "border-b mb-8",
                    "flex justify-between items-center"
                  ])
            });
}

var Navbar = {
  Link: Link,
  make: PropertyPage__Navbar$Navbar
};

var convertFragment = PropertyPageNavbar_property_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyPageNavbar_property_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyPageNavbar_property_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyPageNavbar_property_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyPageNavbar_property_graphql.node, convertFragment, fRef);
}

var Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyPage__Navbar(props) {
  var property = use(props.property);
  var shouldShowPropertyDetails = UseShouldShowPropertyDetails.use(property.fragmentRefs);
  var totalImages = Core__Option.getOr(Core__Option.map(property.imageCount, (function (c) {
              return c.totalCount;
            })), 0);
  var totalFiles = Core__Option.getOr(Core__Option.map(property.fileCount, (function (c) {
              return c.totalCount;
            })), 0);
  var match = property.__typename;
  var propertyType = match === "ForSalePropertyV5" ? "ForSale" : "Rental";
  return JsxRuntime.jsx(PropertyPage__Navbar$Navbar, {
              hasImages: totalImages > 0,
              hasFiles: totalFiles > 0,
              propertyType: propertyType,
              shouldShowPropertyDetails: shouldShowPropertyDetails,
              propertyId: property.id
            });
}

var make = PropertyPage__Navbar;

exports.Navbar = Navbar;
exports.Fragment = Fragment;
exports.make = make;
/* Env Not a pure module */
